import { Avatar, Typography } from "@mui/material";

interface Card {
  id: string;
  style?: React.CSSProperties;
  imgSrc: any; // The image path as a string
  description: string; // The main description
  SubDescription: string; // The sub-description
}

const LogoCard = (props: Card) => {
  const { imgSrc, description, SubDescription, id, style } = props;

  return (
    <>
      <div className="card-container" style={style}>
        <div>
          <Avatar
            alt="Cindy Baker"
            src={imgSrc}
            sx={{
              width: 56,
              height: 56,
              "& img": {
                width: "auto !important", // Prevents it from taking full width
                // height: "auto !important", // Prevents forced height
                objectFit: "cover", // Keeps the aspect ratio
              },
            }}
          />
        </div>
        <div className="desc-container">
          <Typography
            sx={{
              color: "#01060B",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            {description}
          </Typography>
          <Typography
            sx={{
              color: "#6C6F71",
              fontSize: "13px",
              fontWeight: "400",
            }}
          >
            {SubDescription}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default LogoCard;
